import { useState, useCallback } from 'react'
import Link from 'next/link'

import 'intersection-observer'
import Observer from '@researchgate/react-intersection-observer'

// Components
import LinkArrow from 'library/Icons/LinkArrow'
import ResponsiveImage from 'components/ResponsiveImage'

// Styles
import theme from 'styles/theme.js'
import {
  Wrapper,
  FlexContainer,
  Figure,
  Info,
  Title,
  Summary,
  Button
} from './style.js'

const Card = ({ title, slug, card_image, reverse, text }) => {
  const [isAnimationStarted, setIsAnimationStarted] = useState(false)

  const handleIntersection = useCallback(
    event => {
      if (!isAnimationStarted && event.isIntersecting)
        setIsAnimationStarted(true)
    },
    [isAnimationStarted]
  )

  const options = {
    onChange: handleIntersection,
    rootMargin: '0px 0px -200px 0px'
  }

  return (
    <Wrapper>
      <Observer {...options}>
        <FlexContainer
          reverse={reverse}
          className={isAnimationStarted ? 'active' : ''}
        >
          <Figure>
            {card_image ? (
              <Link
                href={`/midias/[midias]?slug=${slug}`}
                as={`/midias/${slug}`}
                passHref
              >
                <a title={title}>
                  <ResponsiveImage
                    image={card_image}
                    alt={title}
                    sizes={`
                        (max-width: ${theme.breakpoints.phone - 1}px) 100vw,
                        (max-width: 1248px) 42vw,
                        524px
                      `}
                  />
                </a>
              </Link>
            ) : (
              <ResponsiveImage image={card_image} />
            )}
          </Figure>
          <Info>
            <Title>{title}</Title>
            <Summary dangerouslySetInnerHTML={{ __html: text }} />
            <Button>
              <Link
                href={`/midias/[midias]?slug=${slug}`}
                as={`/midias/${slug}`}
                passHref
              >
                <a title={title}>
                  Ler mais
                  <LinkArrow />
                </a>
              </Link>
            </Button>
          </Info>
        </FlexContainer>
      </Observer>
    </Wrapper>
  )
}

Card.defaultProps = {
  title: 'Título',
  image: null,
  reverse: false,
  text:
    '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce sagittis dolor. Sed varius vestibulum tortor ut blandit. Duis ullamcorper quam vitae turpis tristique, non posuere tortor ultrices. Curabitur dapibus libero quis scelerisque laoreet. Aenean rhoncus orci a enim mollis ullamcorper.</p>'
}

export default Card
